import React from 'react';
import api from '../Api';
const UserPreferencesContext = React.createContext();

export const connectToUserPreferences = Component => {
	return props => {
		return (
			<UserPreferencesContext.Consumer>
				{userPreferences => {
					return (
						<Component
							{...props}
							userPreferences={userPreferences}
						/>
					);
				}}
			</UserPreferencesContext.Consumer>
		);
	};
};

export default class UserPreferences extends React.Component {
	state = {
		fonts: {
			accentFontColor: '#005373',
		},
	};

	render() {
		return (
			<UserPreferencesContext.Provider value={this.state}>
				{this.props.children}
			</UserPreferencesContext.Provider>
		);
	}

	componentDidMount() {
		this.fetchUserPreferences();
	}

	fetchUserPreferences() {
		var userPreferenceDtosFilter = [
			{ type: 'fonts', name: 'accFontOption' },
		];
		api.post(
			'/api/v1/me/preferences?format=object',
			userPreferenceDtosFilter,
		).then(prefsResult => {
			if (typeof prefsResult !== 'undefined' && prefsResult !== null) {
				this.setState(prefsResult);
			}
		});
	}
}
